class filterListRow {
    constructor(filterlist, filterLinks, filterCols) {
        this.filterList = filterlist;
        if (this.filterList.hasClass('kw-tab--with-filter')) {
            this.withFilter = true;
        } else {
            this.withFilter = false;
        }
        this.filterLinks = filterLinks;
        this.filterCols = filterCols;


        const that = this;
        this.filterLinks.each(function () {
            $(this).on('click tap', function (e) {
                if ($(this).parent().hasClass('kw-tab__link-filter')) {
                    that.openFilter($(this));
                } else {
                    that.changeTab($(this));
                }

                e.preventDefault();
            })
        })
    }

    changeTab(el) {
        const that = this;
        let curCol = el.data('show');
        that.filterCols.removeClass('kw-tab__col--cur');
        that.filterLinks.removeClass('current');
        el.addClass('current');
        $('.' + curCol).addClass('kw-tab__col--cur');
        if (that.withFilter === true) {

            if (el.hasClass('no-filter')) {
                $('.kw-tab__filter').toggleClass('active');
                $('.kw-tab__link-filter').addClass('deactive');
            } else {
                $('.kw-tab__link-filter').removeClass('deactive');
            }
        }
    }

    openFilter(el) {
        const that = this;
        $('.kw-tab__filter').toggleClass('active');
    }

}